<main class="terminal">
    <div id="background"></div>
    <header>
        <header-component></header-component>
        <div class="description" v-if="getGuestName() || app.code">
            <div>
                <h3>{{ getGuestName() }}</h3>
                <div class="status" v-if="!app.checkedin">
                    {{ _('not_checked_in') }}
                </div>
                <div
                    class="status checkedin"
                    v-else-if="app.checkedin && !this.app.checkedout"
                >
                    {{ _('checkedin') }}
                </div>
                <div class="status" v-else-if="app.checkedout">
                    {{ _('checkedout') }}
                </div>
            </div>
        </div>
    </header>
    <div class="detail">
        <div class="first-section">
            <div class="house_name">
                <h3>{{ _(app.house.name) }}</h3>
            </div>
            <div class="accommodation_period">
                <h2>
                    <span class="icon">event_available</span>{{
                    _('accommodation_period') }}
                </h2>
                <div class="accommodation_period_content">
                    <div class="stay-date">
                        <div class="time_label">{{ _('checkin') }}</div>
                        <div class="date-time">
                            <span>{{ formatDate(app.reserve.checkin) }}</span>
                            <div
                                v-if="app.display_time_of_stay_dates"
                                class="stay-time"
                            >
                                <span class="symbol fill">schedule</span>
                                <span
                                    >{{ formatTime(app.reserve.checkin) }}</span
                                >
                            </div>
                        </div>
                    </div>
                    <div class="stay-date">
                        <div class="time_label">{{ _('checkout') }}</div>
                        <div class="date-time">
                            <span>{{ formatDate(app.reserve.checkout) }}</span>
                            <div
                                v-if="app.display_time_of_stay_dates"
                                class="stay-time"
                            >
                                <span class="symbol fill">schedule</span>
                                <span
                                    >{{ formatTime(app.reserve.checkout)
                                    }}</span
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="payment_tools">
                <button v-if="usePayment()" @click="clickPaymentButton()">
                    <span class="symbol fill">credit_card</span>{{
                    paymentButtonLabel() }}
                </button>
                <button
                    v-if="app.downloadable_invoice"
                    class="secondary"
                    :class="{disabled: !app.checkedout}"
                    @click="setIssueReceiptPage"
                >
                    <span class="symbol">receipt_long</span>{{
                    _('receipt_issuance') }}
                </button>
            </div>
            <div v-if="showIssuanceNotice" class="receipt_issuance_notice">
                {{_('receipt_issuance_notice')}}
            </div>
        </div>
        <div class="menu" @click="app.openHouseInfo()" v-if="displayHouseInfo">
            <div class="menu_content">
                <div class="menu_icon">
                    <span class="symbol">menu_book</span>
                </div>
                <div class="menu_description">
                    <h3>{{_('facility_introduction')}}</h3>
                    <p>{{_('facility_introduction_description')}}</p>
                </div>
            </div>
            <div class="menu_arrow">
                <span class="icon">keyboard_arrow_right</span>
            </div>
        </div>
        <div class="menu" v-if="app.code" @click="showCode()">
            <div class="menu_content">
                <div class="menu_icon"><span class="symbol">qr_code</span></div>
                <div class="menu_description">
                    <h3>{{_('checkin')}}・{{_('checkout')}}</h3>
                    <p>{{_('qr_checkin_description')}}</p>
                </div>
            </div>
            <div class="menu_arrow">
                <span class="icon">keyboard_arrow_right</span>
            </div>
        </div>
        <div
            class="menu"
            v-if="app.enabled_mobile_order && app.mobile_order_merchandises.length && app.reserve.room_count"
            @click="app.setPage('MerchandiseCategories')"
        >
            <div class="menu_content">
                <div class="menu_icon">
                    <span class="symbol">restaurant</span>
                </div>
                <div class="menu_description">
                    <h3>{{_('mobile_order')}}</h3>
                    <p>{{_('qr_checkin_description')}}</p>
                </div>
            </div>
            <div class="menu_arrow">
                <span class="icon">keyboard_arrow_right</span>
            </div>
        </div>
        <div
            class="menu"
            v-if="app.showGratuity()"
            @click="app.setPage('GratuityList')"
        >
            <div class="menu_content">
                <div class="menu_icon">
                    <span class="symbol">volunteer_activism</span>
                </div>
                <div class="menu_description">
                    <h3>{{ _(app.gratuity.texts.button_title)}}</h3>
                    <p>{{ _(app.gratuity.texts.button_message)}}</p>
                </div>
            </div>
            <div class="menu_arrow">
                <span class="icon">keyboard_arrow_right</span>
            </div>
        </div>
        <div class="menu" @click="app.setPage('Menu')">
            <div class="menu_content">
                <div class="menu_icon">
                    <span class="symbol">account_circle</span>
                </div>
                <div class="menu_description">
                    <h3>{{_('my_page')}}</h3>
                    <p>{{_('my_page_description')}}</p>
                </div>
            </div>
            <div class="menu_arrow">
                <span class="icon">keyboard_arrow_right</span>
            </div>
        </div>
        <div
            class="menu"
            v-if="app.lockstateQrExist"
            @click="showLockstateQr()"
        >
            <div class="menu_content">
                <div class="menu_icon">
                    <span class="symbol">qr_code_2</span>
                </div>
                <div class="menu_description">
                    <h3>{{_('qr_code_for_unlocking')}}</h3>
                    <p>{{_('description_of_qr_code_for_unlocking')}}</p>
                </div>
            </div>
            <div class="menu_arrow">
                <span class="icon">keyboard_arrow_right</span>
            </div>
        </div>
        <div
            class="menu"
            v-if="app.checkedin && app.reserves_rooms.find(rr => rr.ssid)"
            @click="app.setPage('House')"
        >
            <div class="menu_content">
                <div class="menu_icon"><span class="symbol">wifi</span></div>
                <div class="menu_description">
                    <h3>WiFi</h3>
                </div>
            </div>
            <div class="menu_arrow">
                <span class="icon">keyboard_arrow_right</span>
            </div>
        </div>
    </div>
    <div>
        <div class="reserve_info" v-if="app.house.caution">
            <hr />
            <section class="remarks">
                <pre>※ {{_('cautions')}}<br>{{ _(app.house.caution) }}</pre>
            </section>
            <hr />
        </div>
    </div>
    <tab-bar
        :page="app.query.page"
        :show-notice="showNotice"
        key="showNotice"
    ></tab-bar>
</main>
